export const stageList = [
    {
        id: 27188,
        name: `${i18next.t('demoMock.stageList.first_stage.name')} 1`,
        number: '1',
        planned: {
            start_date: '2024-02-12T00:00:00+03:00',
            end_date: '2024-03-15T00:00:00+03:00',
            days_count: 33,
        },
        actual: {
            start_date: null,
            end_date: null,
            days_count: null,
        },
        done_percent: 5.55555555,
        positions: [
            {
                id: 512579,
                name: i18next.t('demoMock.stageList.first_stage.positions.1'),
                number: '1',
                planned: {
                    start_date: '2024-02-12T00:00:00+03:00',
                    end_date: '2024-02-26T00:00:00+03:00',
                    days_count: 15,
                },
                actual: {
                    start_date: null,
                    end_date: null,
                    days_count: null,
                },
                done_percent: 16.66666666,
                children: [
                    {
                        id: 512575,
                        name: i18next.t('demoMock.stageList.first_stage.positions.2'),
                        number: '1.1',
                        planned: {
                            start_date: '2024-02-15T00:00:00+03:00',
                            end_date: '2024-02-20T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '6f8c2f88-492f-4a83-a298-3a287cc772d2',
                                type: 0,
                            },
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '8167be37-00e7-4e01-a700-4f259c5cbc88',
                                type: 1,
                            },
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '6c6ed315-6992-47c2-b0e1-6fb291a02607',
                                type: 1,
                            },
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '77c8c10e-4afb-4f91-9b51-b3c21296abef',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 8,
                        unit: 'ч/ч',
                        guid: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 512576,
                        name: i18next.t('demoMock.stageList.first_stage.positions.3'),
                        number: '1.2',
                        planned: {
                            start_date: '2024-02-21T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '6f8c2f88-492f-4a83-a298-3a287cc772d2',
                                to: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                type: 0,
                            },
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '6f8c2f88-492f-4a83-a298-3a287cc772d2',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 12,
                        unit: 'ч/ч',
                        guid: '6f8c2f88-492f-4a83-a298-3a287cc772d2',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 512577,
                        name: i18next.t('demoMock.stageList.first_stage.positions.4'),
                        number: '1.3',
                        planned: {
                            start_date: '2024-02-12T00:00:00+03:00',
                            end_date: '2024-02-14T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '8167be37-00e7-4e01-a700-4f259c5cbc88',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: 'рейс',
                        guid: '8167be37-00e7-4e01-a700-4f259c5cbc88',
                        type: 'machinery',
                        is_canceled: false,
                    },
                    {
                        id: 512578,
                        name: i18next.t('demoMock.stageList.first_stage.positions.5'),
                        number: '1.4',
                        planned: {
                            start_date: '2024-02-12T00:00:00+03:00',
                            end_date: '2024-02-14T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                                to: '6c6ed315-6992-47c2-b0e1-6fb291a02607',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: 'дней',
                        guid: '6c6ed315-6992-47c2-b0e1-6fb291a02607',
                        type: 'machinery',
                        is_canceled: false,
                    },
                ],
                connections: [],
                is_parent: true,
                quantity: null,
                unit: null,
                guid: '7f02c90e-e038-437a-b098-83ecfe46fdd9',
                type: null,
                is_canceled: false,
            },
            {
                id: 512588,
                name: i18next.t('demoMock.stageList.first_stage.positions.14'),
                number: '2',
                planned: {
                    start_date: '2024-02-24T00:00:00+03:00',
                    end_date: '2024-03-15T00:00:00+03:00',
                    days_count: 21,
                },
                actual: {
                    start_date: null,
                    end_date: null,
                    days_count: null,
                },
                done_percent: 0,
                children: [
                    {
                        id: 512580,
                        name: i18next.t('demoMock.stageList.first_stage.positions.6'),
                        number: '2.1',
                        planned: {
                            start_date: '2024-02-27T00:00:00+03:00',
                            end_date: '2024-03-03T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: '26c28e84-4841-46f1-b9a2-da38529a9efd',
                                type: 0,
                            },
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: 'c5808c6c-d534-4831-a9b1-fd1b0c8bf698',
                                type: 1,
                            },
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: 'e3184b9e-def6-4c48-b62d-2225d56ebd92',
                                type: 1,
                            },
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: '2cad1592-0d74-4e28-84be-0a0c328af1ac',
                                type: 1,
                            },
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: '030dff69-db9b-44f6-b406-34e5cb6b2ba8',
                                type: 1,
                            },
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: 'd79dbd71-4797-4e9f-82f9-fe07414b1211',
                                type: 1,
                            },
                            {
                                from: '6f8c2f88-492f-4a83-a298-3a287cc772d2',
                                to: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 130,
                        unit: 'м2',
                        guid: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 512581,
                        name: i18next.t('demoMock.stageList.first_stage.positions.7'),
                        number: '2.2',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: 'c5808c6c-d534-4831-a9b1-fd1b0c8bf698',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 10,
                        unit: 'л',
                        guid: 'c5808c6c-d534-4831-a9b1-fd1b0c8bf698',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 512582,
                        name: i18next.t('demoMock.stageList.first_stage.positions.8'),
                        number: '2.3',
                        planned: {
                            start_date: '2024-03-04T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '26c28e84-4841-46f1-b9a2-da38529a9efd',
                                to: '1813dab2-bbef-4afc-973b-1c39ee954ec0',
                                type: 0,
                            },
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: '26c28e84-4841-46f1-b9a2-da38529a9efd',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 130,
                        unit: 'м2',
                        guid: '26c28e84-4841-46f1-b9a2-da38529a9efd',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 512583,
                        name: i18next.t('demoMock.stageList.first_stage.positions.9'),
                        number: '2.4',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: 'e3184b9e-def6-4c48-b62d-2225d56ebd92',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 15,
                        unit: 'меш',
                        guid: 'e3184b9e-def6-4c48-b62d-2225d56ebd92',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 512584,
                        name: i18next.t('demoMock.stageList.first_stage.positions.10'),
                        number: '2.5',
                        planned: {
                            start_date: '2024-03-10T00:00:00+03:00',
                            end_date: '2024-03-15T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '26c28e84-4841-46f1-b9a2-da38529a9efd',
                                to: '1813dab2-bbef-4afc-973b-1c39ee954ec0',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 130,
                        unit: 'м2',
                        guid: '1813dab2-bbef-4afc-973b-1c39ee954ec0',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 512585,
                        name: i18next.t('demoMock.stageList.first_stage.positions.11'),
                        number: '2.6',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: '2cad1592-0d74-4e28-84be-0a0c328af1ac',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: 'компл',
                        guid: '2cad1592-0d74-4e28-84be-0a0c328af1ac',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 512586,
                        name: i18next.t('demoMock.stageList.first_stage.positions.12'),
                        number: '2.7',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: '030dff69-db9b-44f6-b406-34e5cb6b2ba8',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 10,
                        unit: 'уп',
                        guid: '030dff69-db9b-44f6-b406-34e5cb6b2ba8',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 512587,
                        name: i18next.t('demoMock.stageList.first_stage.positions.13'),
                        number: '2.8',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '0619a905-cf20-4b38-8b85-70ae696fb14c',
                                to: 'd79dbd71-4797-4e9f-82f9-fe07414b1211',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: '-',
                        guid: 'd79dbd71-4797-4e9f-82f9-fe07414b1211',
                        type: 'material',
                        is_canceled: false,
                    },
                ],
                connections: [],
                is_parent: true,
                quantity: null,
                unit: null,
                guid: '797240c0-4588-48d7-afbc-28ba478239ac',
                type: null,
                is_canceled: false,
            },
            {
                id: 512589,
                name: i18next.t('demoMock.stageList.first_stage.positions.14'),
                number: '3',
                planned: {
                    start_date: '2024-02-12T00:00:00+03:00',
                    end_date: '2024-02-14T00:00:00+03:00',
                    days_count: 3,
                },
                actual: {
                    start_date: null,
                    end_date: null,
                    days_count: null,
                },
                done_percent: 0,
                children: [],
                connections: [
                    {
                        from: '4602c431-a5af-4dc8-a4da-9da5e610508e',
                        to: '77c8c10e-4afb-4f91-9b51-b3c21296abef',
                        type: 1,
                    },
                ],
                is_parent: false,
                quantity: 1,
                unit: 'рейс',
                guid: '77c8c10e-4afb-4f91-9b51-b3c21296abef',
                type: 'shipping',
                is_canceled: false,
            },
        ],
    },
    {
        id: 29193,
        name: `${i18next.t('demoMock.stageList.first_stage.name')} 2`,
        number: '2',
        planned: {
            start_date: '2024-02-24T00:00:00+03:00',
            end_date: '2024-03-27T00:00:00+03:00',
            days_count: 33,
        },
        actual: {
            start_date: null,
            end_date: null,
            days_count: null,
        },
        done_percent: 0,
        positions: [
            {
                id: 612445,
                name: i18next.t('demoMock.stageList.first_stage.positions.1'),
                number: '1',
                planned: {
                    start_date: '2024-02-24T00:00:00+03:00',
                    end_date: '2024-03-09T00:00:00+03:00',
                    days_count: 15,
                },
                actual: {
                    start_date: null,
                    end_date: null,
                    days_count: null,
                },
                done_percent: 0,
                children: [
                    {
                        id: 612446,
                        name: i18next.t('demoMock.stageList.first_stage.positions.2'),
                        number: '1.1',
                        planned: {
                            start_date: '2024-02-27T00:00:00+03:00',
                            end_date: '2024-03-03T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: '81455f45-390e-7835-b828-fd1fb80f8569',
                                type: 0,
                            },
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: 'f649ba81-abbe-12bc-26de-678798570a9a',
                                type: 1,
                            },
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: 'f18a9cd8-16fd-1dec-2dfd-3e282209cfff',
                                type: 1,
                            },
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: '206c3e73-94df-1406-2157-ca019c1d5da1',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 8,
                        unit: 'ч/ч',
                        guid: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 612447,
                        name: i18next.t('demoMock.stageList.first_stage.positions.3'),
                        number: '1.2',
                        planned: {
                            start_date: '2024-03-04T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '81455f45-390e-7835-b828-fd1fb80f8569',
                                to: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                type: 0,
                            },
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: '81455f45-390e-7835-b828-fd1fb80f8569',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 12,
                        unit: 'ч/ч',
                        guid: '81455f45-390e-7835-b828-fd1fb80f8569',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 612448,
                        name: i18next.t('demoMock.stageList.first_stage.positions.4'),
                        number: '1.3',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: 'f649ba81-abbe-12bc-26de-678798570a9a',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: 'рейс',
                        guid: 'f649ba81-abbe-12bc-26de-678798570a9a',
                        type: 'machinery',
                        is_canceled: false,
                    },
                    {
                        id: 612449,
                        name: i18next.t('demoMock.stageList.first_stage.positions.5'),
                        number: '1.4',
                        planned: {
                            start_date: '2024-02-24T00:00:00+03:00',
                            end_date: '2024-02-26T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                                to: 'f18a9cd8-16fd-1dec-2dfd-3e282209cfff',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: 'дней',
                        guid: 'f18a9cd8-16fd-1dec-2dfd-3e282209cfff',
                        type: 'machinery',
                        is_canceled: false,
                    },
                ],
                connections: [],
                is_parent: true,
                quantity: null,
                unit: null,
                guid: 'cf3a2faa-fc68-dc63-76d5-876038cfc2d2',
                type: null,
                is_canceled: false,
            },
            {
                id: 612450,
                name: 'Отделка',
                number: '2',
                planned: {
                    start_date: '2024-03-07T00:00:00+03:00',
                    end_date: '2024-03-27T00:00:00+03:00',
                    days_count: 21,
                },
                actual: {
                    start_date: null,
                    end_date: null,
                    days_count: null,
                },
                done_percent: 0,
                children: [
                    {
                        id: 612451,
                        name: i18next.t('demoMock.stageList.first_stage.positions.6'),
                        number: '2.1',
                        planned: {
                            start_date: '2024-03-10T00:00:00+03:00',
                            end_date: '2024-03-15T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: 'da533c95-de34-e4d1-5b2a-d5b0f6e21c86',
                                type: 0,
                            },
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '0a74ebd5-f1cc-ed45-ba25-fdb3f3ff6cae',
                                type: 1,
                            },
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '5467ad1b-9301-969e-9561-5ad2f5bd6809',
                                type: 1,
                            },
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '6b2799e1-971c-bdda-80a6-85e95bd65829',
                                type: 1,
                            },
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: 'eccd0731-8716-1c9e-18f3-d839eac4d53d',
                                type: 1,
                            },
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '0a0532df-9f8e-e855-d612-327ad2498bfe',
                                type: 1,
                            },
                            {
                                from: '81455f45-390e-7835-b828-fd1fb80f8569',
                                to: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 130,
                        unit: 'м2',
                        guid: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 612452,
                        name: i18next.t('demoMock.stageList.first_stage.positions.7'),
                        number: '2.2',
                        planned: {
                            start_date: '2024-03-07T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '0a74ebd5-f1cc-ed45-ba25-fdb3f3ff6cae',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 10,
                        unit: 'л',
                        guid: '0a74ebd5-f1cc-ed45-ba25-fdb3f3ff6cae',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 612453,
                        name: 'Штукатурка стен',
                        number: '2.3',
                        planned: {
                            start_date: '2024-03-16T00:00:00+03:00',
                            end_date: '2024-03-21T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: 'da533c95-de34-e4d1-5b2a-d5b0f6e21c86',
                                to: 'bd0d8068-96f0-7699-a6ad-7cae8075360f',
                                type: 0,
                            },
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: 'da533c95-de34-e4d1-5b2a-d5b0f6e21c86',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 130,
                        unit: 'м2',
                        guid: 'da533c95-de34-e4d1-5b2a-d5b0f6e21c86',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 612454,
                        name: i18next.t('demoMock.stageList.first_stage.positions.8'),
                        number: '2.4',
                        planned: {
                            start_date: '2024-03-07T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '5467ad1b-9301-969e-9561-5ad2f5bd6809',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 15,
                        unit: 'меш',
                        guid: '5467ad1b-9301-969e-9561-5ad2f5bd6809',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 612455,
                        name: i18next.t('demoMock.stageList.first_stage.positions.9'),
                        number: '2.5',
                        planned: {
                            start_date: '2024-03-22T00:00:00+03:00',
                            end_date: '2024-03-27T00:00:00+03:00',
                            days_count: 6,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: 'da533c95-de34-e4d1-5b2a-d5b0f6e21c86',
                                to: 'bd0d8068-96f0-7699-a6ad-7cae8075360f',
                                type: 0,
                            },
                        ],
                        is_parent: false,
                        quantity: 130,
                        unit: 'м2',
                        guid: 'bd0d8068-96f0-7699-a6ad-7cae8075360f',
                        type: 'labor',
                        is_canceled: false,
                    },
                    {
                        id: 612456,
                        name: i18next.t('demoMock.stageList.first_stage.positions.10'),
                        number: '2.6',
                        planned: {
                            start_date: '2024-03-07T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '6b2799e1-971c-bdda-80a6-85e95bd65829',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: 'компл',
                        guid: '6b2799e1-971c-bdda-80a6-85e95bd65829',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 612457,
                        name: i18next.t('demoMock.stageList.first_stage.positions.11'),
                        number: '2.7',
                        planned: {
                            start_date: '2024-03-07T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: 'eccd0731-8716-1c9e-18f3-d839eac4d53d',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 10,
                        unit: 'уп',
                        guid: 'eccd0731-8716-1c9e-18f3-d839eac4d53d',
                        type: 'material',
                        is_canceled: false,
                    },
                    {
                        id: 612458,
                        name: i18next.t('demoMock.stageList.first_stage.positions.12'),
                        number: '2.8',
                        planned: {
                            start_date: '2024-03-07T00:00:00+03:00',
                            end_date: '2024-03-09T00:00:00+03:00',
                            days_count: 3,
                        },
                        actual: {
                            start_date: null,
                            end_date: null,
                            days_count: null,
                        },
                        done_percent: 0,
                        children: [],
                        connections: [
                            {
                                from: '3e747917-7de4-7dc4-7f2a-4997c4dee65f',
                                to: '0a0532df-9f8e-e855-d612-327ad2498bfe',
                                type: 1,
                            },
                        ],
                        is_parent: false,
                        quantity: 1,
                        unit: '-',
                        guid: '0a0532df-9f8e-e855-d612-327ad2498bfe',
                        type: 'material',
                        is_canceled: false,
                    },
                ],
                connections: [],
                is_parent: true,
                quantity: null,
                unit: null,
                guid: 'baa39d97-40b7-a9e7-ff54-1df3e7d95747',
                type: null,
                is_canceled: false,
            },
            {
                id: 612459,
                name: i18next.t('demoMock.stageList.first_stage.positions.13'),
                number: '3',
                planned: {
                    start_date: '2024-02-24T00:00:00+03:00',
                    end_date: '2024-02-26T00:00:00+03:00',
                    days_count: 3,
                },
                actual: {
                    start_date: null,
                    end_date: null,
                    days_count: null,
                },
                done_percent: 0,
                children: [],
                connections: [
                    {
                        from: 'e1704db3-0265-b62a-4fcb-7ccb4f6b9bcd',
                        to: '206c3e73-94df-1406-2157-ca019c1d5da1',
                        type: 1,
                    },
                ],
                is_parent: false,
                quantity: 1,
                unit: 'рейс',
                guid: '206c3e73-94df-1406-2157-ca019c1d5da1',
                type: 'shipping',
                is_canceled: false,
            },
        ],
    },
];
